export default {
  play: `${process.env.PUBLIC_URL}/images/icons/play.svg`,
  done: `${process.env.PUBLIC_URL}/images/icons/done.svg`,
  black_lock: `${process.env.PUBLIC_URL}/images/icons/black-lock.svg`,
  royal_lock: `${process.env.PUBLIC_URL}/images/icons/royal-lock.svg`,
  header_bg: `${process.env.PUBLIC_URL}/images/header/header-mask.svg`,
  back_arrow: `${process.env.PUBLIC_URL}/images/icons/back-button-icon.svg`,
  congrats_chips: `${process.env.PUBLIC_URL}/images/congrats-chips.svg`,
  kids_bg: `${process.env.PUBLIC_URL}/images/Celebrate_empty.png`,
  close: `${process.env.PUBLIC_URL}/images/icons/close.svg`,
  arrow: `${process.env.PUBLIC_URL}/images/icons/arrow.svg`,
  wrong: `${process.env.PUBLIC_URL}/images/icons/wrong.svg`,
  correct: `${process.env.PUBLIC_URL}/images/icons/correct.svg`,
  decline: `${process.env.PUBLIC_URL}/images/icons/recycleRIGHT/decline.svg`,
  great_job: `${process.env.PUBLIC_URL}/images/icons/recycleRIGHT/great-job.svg`,
  happy_emoji: `${process.env.PUBLIC_URL}/images/icons/recycleRIGHT/happy-emoji.svg`,
  on_boarding_arrow: `${process.env.PUBLIC_URL}/images/icons/recycleRIGHT/on-boarding-arrow.svg`,
  on_boarding: `${process.env.PUBLIC_URL}/images/icons/recycleRIGHT/on-boarding.svg`,
  recycable: `${process.env.PUBLIC_URL}/images/icons/recycleRIGHT/recycable.svg`,
  recycle_right: `${process.env.PUBLIC_URL}/images/icons/recycleRIGHT/recycle-right.svg`,
  sad_emoji: `${process.env.PUBLIC_URL}/images/icons/recycleRIGHT/sad-emoji.svg`,
  time_out: `${process.env.PUBLIC_URL}/images/icons/recycleRIGHT/time-out.svg`,
  timer: `${process.env.PUBLIC_URL}/images/icons/recycleRIGHT/timer.svg`,
  arrow_left: `${process.env.PUBLIC_URL}/images/icons/recycleRIGHT/arrow-left.svg`,
  level_completed: `${process.env.PUBLIC_URL}/images/icons/recycleRIGHT/level-completed.svg`,
  oops_feedback: `${process.env.PUBLIC_URL}/images/icons/recycleRIGHT/oops-feedback.svg`,
  good_job_feedback: `${process.env.PUBLIC_URL}/images/icons/recycleRIGHT/good-job-feedback.svg`,
};
